import InputColor from '@/components/sections/builder/theme/color/input-color';
import { ThemeColorSchemeType } from '@/stores/builder';
import { CheckIcon, Trash2Icon, X } from 'lucide-react';
import React, { SetStateAction } from 'react';

type ColorSchemeFormProps = {
  scheme: ThemeColorSchemeType;
  onChange: (scheme: Partial<ThemeColorSchemeType>) => void;
  onClose?: (id?: number) => void;
  cancelChoice?: React.Dispatch<SetStateAction<ThemeColorSchemeType | undefined>>;
};

export default function ColorSchemeForm({
  scheme,
  onChange,
  onClose,
  cancelChoice,
}: ColorSchemeFormProps) {
  const [valScheme, setValScheme] = React.useState<object | ThemeColorSchemeType>(scheme);

  const onChangeColor = (value: Partial<ThemeColorSchemeType>) => {
    setValScheme((prev) => ({ ...prev, ...value }));
  };

  const saveColorScheme = () => {
    if (Object.keys(valScheme).length > 0) {
      onChange({ id: Number(scheme.id), ...valScheme });
      if (cancelChoice) cancelChoice(undefined);
    }
  };

  const handleCancel = () => {
    if (cancelChoice) cancelChoice(undefined);
  };

  return (
    <div>
      <div className='mb-6 flex items-center justify-between'>
        <div>
          <div className='font-bold'>Editing Scheme {scheme.id}</div>
        </div>
        <div className='flex items-center gap-x-1'>
          {onClose && (
            <>
              <button
                type='button'
                className='rounded-sm px-1 py-0.5 text-xs duration-300 hover:bg-slate-100'
                onClick={handleCancel}
              >
                <X className='h-4 w-4' />
              </button>
              <button
                type='button'
                onClick={() => onClose?.(scheme.id)}
                className='rounded-sm px-1 py-0.5 text-xs duration-300 hover:bg-slate-100'
              >
                <Trash2Icon className='h-4 w-4' />
              </button>
            </>
          )}
          <button
            type='button'
            onClick={saveColorScheme}
            className='rounded-sm px-1 py-0.5 text-xs duration-300 hover:bg-slate-100'
          >
            <CheckIcon className='h-4 w-4' />
          </button>
        </div>
      </div>
      <InputColor
        defaultColor={scheme.background}
        label='Background'
        onChangeColor={(v) => onChangeColor({ background: v })}
      />
      <InputColor
        defaultColor={scheme.text}
        label='Text Primary'
        onChangeColor={(v) => onChangeColor({ text: v })}
      />
      <InputColor
        defaultColor={scheme.textSecondary}
        label='Text Secondary'
        onChangeColor={(v) => onChangeColor({ textSecondary: v })}
      />
      <InputColor
        defaultColor={scheme.btnSolidBackgroud}
        label='Button Background'
        onChangeColor={(v) => onChangeColor({ btnSolidBackgroud: v })}
      />
      <InputColor
        defaultColor={scheme.btnSolidlabel}
        label='Button Label'
        onChangeColor={(v) => onChangeColor({ btnSolidlabel: v })}
      />
      <InputColor
        defaultColor={scheme.btnOutline}
        label='Button Outline'
        onChangeColor={(v) => onChangeColor({ btnOutline: v })}
      />
      <InputColor
        defaultColor={scheme.shadow}
        label='Shadow'
        onChangeColor={(v) => onChangeColor({ shadow: v })}
      />
      <InputColor
        defaultColor={scheme.imageBackground}
        label='Image Background'
        onChangeColor={(v) => onChangeColor({ imageBackground: v })}
      />
    </div>
  );
}
